import React, { useState } from "react";
import { Beat } from "../../../redux/reducers/spinner";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../redux/actions";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";

function DeleteAddress({ addressData }) {
  const id = addressData?.id;
  const dispatch = useDispatch();

  let dataObject = {
    email: addressData?.email,
    name: addressData?.name,
    phone: addressData?.phone,
    address: addressData?.address,
    city: addressData?.city,
    state: addressData?.state,
    country: addressData?.country,
  };

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const deleting = useSelector((state) => state.admin.deleting);

  const handleSubmit = (event) => {
    event.preventDefault();

    dispatch(userActions.deleteAddress({ id: id }));
  };

  return (
    <div>
      <MDBContainer>
        <MDBBtn
          onClick={() => setOpen(true)}
          title="Delete Address"
          color="primary"
        >
          <span className="mr-2">Delete Address</span>
          <i className="nav-icon i-Close-Window" />
        </MDBBtn>
        <MDBModal isOpen={open} toggle={handleClose}>
          <form name="form" onSubmit={handleSubmit}>
            <MDBModalHeader toggle={handleClose}>Delete Address</MDBModalHeader>
            <MDBModalBody>
              <div className="text-left row pt-4 px-3">
                <h5>
                  Would you like to delete the address named: {dataObject.name},{" "}
                </h5>

                <h5>
                  Located at: {dataObject.address}, {dataObject.city},{" "}
                  {dataObject.state}, {dataObject.country}?
                </h5>
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={() => setOpen(false)}>
                Close
              </MDBBtn>
              <MDBBtn color="primary" type="submit">
                {deleting === true ? (
                  <Beat loading={deleting} />
                ) : (
                  "Delete address"
                )}
              </MDBBtn>
            </MDBModalFooter>
          </form>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default DeleteAddress;
